import { capitalDesignTokens, createTypedSxStyles } from '@opengov/capital-mui-theme';

export const styles = createTypedSxStyles({
  content: {
    minHeight: '40px',
    width: '100%',
    boxSizing: 'border-box',
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    cursor: 'pointer',
    WebkitTapHighlightColor: 'transparent',
    padding: '4px 8px',
    transition: 'background-color 150ms cubic-bezier(0.4, 0, 0.2, 1)',
    borderRight: '4px solid transparent',
    '&:hover': {
      backgroundColor: capitalDesignTokens.foundations.colors.gray200
    },
    '&.Mui-focused': {
      backgroundColor: capitalDesignTokens.foundations.colors.gray200
    }
  },
  contentSelected: {
    borderRight: `4px solid ${capitalDesignTokens.foundations.colors.brand800}`,
    backgroundColor: capitalDesignTokens.foundations.colors.brand50,
    '&:hover': {
      backgroundColor: capitalDesignTokens.foundations.colors.brand200
    },
    '&.Mui-focused': {
      backgroundColor: capitalDesignTokens.foundations.colors.brand200
    }
  },
  icon: {
    display: 'flex',
    width: '0',
    flexShrink: 0,
    justifyContent: 'center',
    '& svg': {
      fontSize: '18px'
    }
  },
  iconHasChildren: {
    width: '16px'
  },
  label: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    flexGrow: 1,
    paddingRight: 0,
    gap: '8px',
    minHeight: '32px',
    flex: '1 1 auto',
    minWidth: '0'
  },
  labelSelected: {
    paddingRight: '32px'
  },
  labelIcon: {
    fill: capitalDesignTokens.foundations.colors.gray500
  },
  labelIconSelected: {
    fill: capitalDesignTokens.foundations.colors.gray800
  },
  labelText: {
    fontWeight: capitalDesignTokens.foundations.typography.fontWeight.normal
  },
  labelTextSelected: {
    fontWeight: capitalDesignTokens.foundations.typography.fontWeight.semiBold
  },
  actionsButton: {
    position: 'absolute',
    right: '16px',
    top: '50%',
    transform: 'translateY(-50%)'
  }
});
